import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import LOOKUP from "constants/lookup";
import Dialog from '@mui/material/Dialog';
import { getBulkMemberPriceCategoryHistory } from "actions/EntityActions";
// Basic Components
import DialogHeaderWithClose from "screens/components/basic/DialogHeaderWithClose";
import GenericTable from "screens/components/advanced/GenericTable";
import DialogInput from "screens/components/advanced/DialogInput";

class CategoryUpdateMemberPriceHistoryList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.getBulkMemberPriceCategoryHistory(this.props.branchId);
    this.setState({ isOpen: this.props.isOpen });
  }
  getCategoryTitle(categoryId) {
    const category = this.props.history.filter(
      (item) => item.productCategoryId == categoryId
    );
    return (
      <Link to={`/employee/edit/${category[0].productCategoryId}`}>
        {category[0].productCategoryTitle}
      </Link>
    );
  }
  getCategoryGroup() {
    const his = [
      ...new Set(this.props.history.map((item) => item.productCategoryId)),
    ];

    if (this.props.allCategory == true) {
      return his.map((catItem) => (
        <li className="list-group-item list-group-item-success">
          <h4>{this.getCategoryTitle(catItem)}</h4>
          <GenericTable
            className="table_center tableHeaderwhiteColorFont"
            stripedRows={true}
            columns={LOOKUP.product.tableColumnsBulkMemberPriceCategoryHistory}
            rows={this.getCategoryData(catItem)}
          />
        </li>
      ));
    }
    else if (this.props.oneCategory == true) {
      return his
        .filter((item) => item == this.props.categoryId)
        .map((catItem) => (
          <li className="list-group-item list-group-item-success">
            <div>{this.getCategoryTitle(catItem)}</div>
            <GenericTable
              className="table_center tableHeaderwhiteColorFont"
              stripedRows={true}
              columns={
                LOOKUP.product.tableColumnsBulkMemberPriceCategoryHistory
              }
              rows={this.getCategoryData(catItem)}
            />
          </li>
        ));
    }
  }
  getCategoryData(categoryId) {
    const his = this.props.history;
    return his
      .filter((item) => item.productCategoryId == categoryId)
      .map((item) => {
        return {
          userTitle: (
            <Link to={`/employee/edit/${item.userId}`}>{item.userTitle}</Link>
          ),
          memberDiscountPercentage:
            item.percepercentageDiscountntage != null
              ? item.percepercentageDiscountntage
              : "-",
          updateCount: item.updateCount != null ? item.updateCount : "-",
          creationDate:
            item.creationDate != null
              ? moment(item.creationDate).format("YYYY-MM-DD")
              : "-",
        };
      });
  }
  render() {
    return (
      <div>
        <DialogInput
          title={<DialogHeaderWithClose text="Bulk Member Prices History" handleClose={() => this.props.onCancel()} />}
          titleStyle={{ textAlign: "center", paddingBottom: `0px` }}
          modal={true}
          open={this.props.isOpen}
          contentStyle={{
            position: "absolute",
            left: "50%",
            width: "900px",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <div
            className="row pb-2 pl-2"
            style={{
              overflowY: `scroll`,
              overflowX: `hidden`,
              maxHeight: `500px`,
            }}
          >
            <ul className="list-group">{this.getCategoryGroup()}</ul>
          </div>
        </DialogInput>
      </div>
    );
  }
}
function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    history: state.entity.bulkUpdateMemberPriceCategoryHistoryList,
    history_lenght: state.entity.bulkUpdateMemberPriceCategoryHistoryListLength,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getBulkMemberPriceCategoryHistory: (branchId) => dispatch(getBulkMemberPriceCategoryHistory(branchId))
  };
}

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(CategoryUpdateMemberPriceHistoryList);
